import type { SqliteOptions } from '../providers/sqlite-options';
import type { SqliteProvider } from '../providers/sqlite.provider';

type SqliteProviderMode = 'straight' | 'worker' | 'opfs' | 'native';

const loadProvider = async (mode: SqliteProviderMode): Promise<SqliteProvider> => {
  switch (mode) {
    case 'worker': {
      const { SqliteWorkerProvider } = await import('../providers/sqlite-worker.provider');
      return new SqliteWorkerProvider();
    }
    case 'opfs': {
      const { SqliteOpfsWorkerProvider } = await import('../providers/sqlite-opfs-worker.provider');
      return new SqliteOpfsWorkerProvider();
    }
    case 'native': {
      const { SqliteNativeProvider } = await import('../providers/sqlite-native.provider');
      return new SqliteNativeProvider();
    }
    case 'straight':
    default: {
      const { SqliteStraightProvider } = await import('../providers/sqlite-straight.provider');
      return new SqliteStraightProvider();
    }
  }
};

export async function createSqliteProvider(
  options: SqliteOptions & { mode?: 'straight' | 'worker' | 'opfs' | 'native'; dbName?: string } = {},
): Promise<SqliteProvider> {
  const provider = await loadProvider(options.mode ?? 'straight');
  await provider.initialize(options);
  return provider;
}
